import { brand } from "../data/siteData";
import "./Contact.css";

export default function Contact() {
  return (
    <section id="contact" className="section contact">
      <div className="contact__grid">
        <div className="contact__left">
          <span className="section-eyebrow">Get In Touch</span>
          <h2 className="section-title">Ready to Protect<br /><em>Your Crops?</em></h2>
          <p className="contact__desc">
            Speak with a AgreezAgro agronomist today. We'll recommend the right product mix for your
            crop, region, and challenge — and get you a competitive quote within 24 hours.
          </p>
          <div className="contact__info">
            {[
              { icon: "📞", val: brand.phone },
              { icon: "✉️", val: brand.email },
              { icon: "📍", val: brand.address },
            ].map((item) => (
              <div className="contact__info-item" key={item.val}>
                <div className="contact__info-icon">{item.icon}</div>
                <span>{item.val}</span>
              </div>
            ))}
          </div>
          <div className="contact__certs">
            {["🌿 Eco Certified", "✅ USDA Reg.", "🔬 ISO 9001", "♻️ Sustainable"].map((c) => (
              <div className="cert-badge" key={c}>{c}</div>
            ))}
          </div>
        </div>

        <form className="contact__form" onSubmit={(e) => e.preventDefault()}>
          <div className="cf__row">
            <div className="cf__field">
              <label>Full Name</label>
              <input type="text" placeholder="John Smith" />
            </div>
            <div className="cf__field">
              <label>Email Address</label>
              <input type="email" placeholder="john@farm.com" />
            </div>
          </div>
          <div className="cf__row">
            <div className="cf__field">
              <label>Crop Type</label>
              <select>
                <option value="">Select a crop…</option>
                <option>Wheat</option><option>Corn</option><option>Soybean</option>
                <option>Rice</option><option>Vegetables</option><option>Fruits</option><option>Other</option>
              </select>
            </div>
            <div className="cf__field">
              <label>Product Interest</label>
              <select>
                <option value="">Select category…</option>
                <option>Pesticide</option>
                <option>Herbicide</option>
                <option>Fungicide</option>
                <option>Complete Program</option>
              </select>
            </div>
          </div>
          <div className="cf__field">
            <label>Message</label>
            <textarea rows="4" placeholder="Tell us about your farm size, main challenge, or specific product enquiry…" />
          </div>
          <button type="submit" className="btn-primary cf__submit">Submit Enquiry →</button>
        </form>
      </div>
    </section>
  );
}
